import { connect, ConnectedProps } from 'react-redux';
import { selectMobileType } from '../../../../selectors/deviceType';
import { IStoreState } from '../../../../types/StoreState';
import { CardDetailsWrapper } from './view';

const connector = connect((state: IStoreState) => ({
  mobile: selectMobileType(state),
}));

export type ICardDetailsWrapperConnectedProps = ConnectedProps<typeof connector>;
export const CardDetailsWrapperConnect = connector(CardDetailsWrapper);
